import { Component, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NotificationService } from 'src/app/services/notification.service';
import { Subscription, timer } from 'rxjs';

interface ToastItem {
  id: string;
  message: string;
  type: string;
}

@Component({
  standalone: true,
  imports: [CommonModule],
  selector: 'app-notification-toast',
  templateUrl: './notification-toast.component.html',
  styleUrls: ['./notification-toast.component.scss']
})
export class NotificationToastComponent implements OnInit, OnDestroy {
  toasts: ToastItem[] = [];
  sub: Subscription | null = null;

  constructor(private notificationService: NotificationService) {}

  ngOnInit(): void {
    this.sub = this.notificationService.transient$.subscribe((n) => {
      const item: ToastItem = { id: n.id, message: n.message, type: n.type };
      this.toasts.unshift(item);

      // Remove after 5 seconds with animation duration matching CSS
      const t = timer(5000).subscribe(() => {
        this.remove(item.id);
        t.unsubscribe();
      });
    });
  }

  remove(id: string) {
    // Start CSS-driven fade/slide by adding a class; but we'll simply remove after timer
    this.toasts = this.toasts.filter(t => t.id !== id);
  }

  ngOnDestroy(): void {
    if (this.sub) this.sub.unsubscribe();
  }
}
